import barba from '@barba/core'
import PageLoader from './animations/pageLoader'
import Navigation from './navigation'
import SmoothScroll from './animations/smoothScroll'
import ButtonHover from './animations/buttonsHover'
import ServiceCards from './animations/serviceCards'
import ThemeChange from './animations/themeChange'
import ProductCategories from './animations/productCategories'
import Heights from './matchHeight'
import GlobalCoverage from './globalCoverage'
import Sliders from './sliders'
import Accordions from './accordions'
import ReadMore from './readMore'
import WooCheckout from './woocommerce/checkout'
import WooFavourite from './woocommerce/favourite'
import MobileFilterTrigger from './woocommerce/mobileFilterTrigger'
import Filters from './woocommerce/filters'
import Render from './woocommerce/render'
import Filter from './filters'
import MobileMenu from './mobileMenu'
import HeaderScroll from './headerScroll'
import Cookies from 'js-cookie'

const loader = new PageLoader

barba.init({
  debug: false,
  preventRunning: true,
  timeout: 5000,
  transitions: [{
    name: 'default-transition',
      leave: async () => {
        await loader.addAnimation()
      },
      once: () => {
        // Force Scroll To Top
        setTimeout(() => {
          window.scrollTo(0,0);
        }, 1);

        if (Cookies.get('loadMinimalLoader') ) {
          loader.minimalAnimation()
          Cookies.remove('loadMinimalLoader')
        } else {
          loader.removeAnimation()
        }
      }
    }]
  })

  barba.hooks.enter((data) => {
    // Force Scroll To Top
    window.scrollTo(0, 0);

    let parser = new DOMParser();
    let futureDom = parser.parseFromString(data.next.html, 'text/html');

    const checkForNF = futureDom.querySelector('.nf-form-cont')
    const checkForWooProduct = futureDom.querySelector('.woocommerce-product-gallery')
    const checkForCheckout = futureDom.querySelector('.c-checkout')
    const checkForCart = futureDom.querySelector('.c-cart')

    console.log(futureDom);

    if (checkForNF || checkForWooProduct || checkForCheckout || checkForCart) {
      Cookies.set('loadMinimalLoader', 'true', { expires: ((1/24)/60) })
      location.reload()
    } else {
      loader.minimalAnimation()
    }
  })

  barba.hooks.before((data) => {
    if (history.scrollRestoration) {
      history.scrollRestoration = 'manual';
    }
  })

  barba.hooks.afterOnce(() => {
    setTimeout(() => {
      pageRequired()
    }, 1500);
})

barba.hooks.after(() => {
  pageRequired()
})

function pageRequired() {
  new Navigation
  new SmoothScroll
  new ButtonHover
  new ServiceCards
  new ThemeChange
  new ProductCategories
  new GlobalCoverage
  new ReadMore
  new MobileMenu
  new HeaderScroll
  Heights()
  Sliders()
  initAccordions()
  Filter()

  WooCheckout()
	WooFavourite()
	MobileFilterTrigger()
	// new Filters()
	new Render()

  document.querySelectorAll("#wpadminbar a").forEach(item=>item.setAttribute('data-barba-prevent','self'));
}


function initAccordions() {
  	const accordionSections = document.querySelectorAll('[data-accordions]')

    if (accordionSections.length) {
      accordionSections.forEach(accordions => {
        setTimeout(() => {
          new Accordions(accordions, '[data-accordion]', true)
        }, 200);
      })
    }
}


// import Scroll from './animations/scroll'

// 	new Scroll(
// 		document.querySelectorAll('[data-fade-in]'),
// 		{
// 			opacity: 0,
// 			top: 20,
// 			position: 'relative'
// 		},
// 		{
// 			opacity: 1,
// 			top: 0,
// 			duration: 1,
// 		}
// 	)
